import React, { useEffect, useState, useRef } from 'react';
import './courseAnimationBar.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveContentTabIndex } from '../../../../C2wStore/actions';
import { useNavigate } from 'react-router';
import { Link } from 'react-scroll';
import { Bounce, toast, ToastContainer } from 'react-toastify';

function C2wCourseAnimationBar({ courseData, handleIndexRef, handlePopup }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const tempIndex = useSelector((state) => state.data.activeContentTabIndex);
  const [toastFlag, setToastFlag] = useState(false)

  /**
 * @state activeIndex
 * @function handleActiveIndex
 * @author Vishal Lohbande
 *
 * Description:
 * - Maintains the currently active index in component state.
 * - `handleActiveIndex` function:
 *   - Calls an external `handleIndexRef` with the provided `index`.
 *   - Uses the result to dispatch an action `setActiveContentTabIndex` to update global state.
 *   - Updates the local `activeIndex` state with the new active index.
 *
 * Usage:
 * - Used to track and update which tab or section is currently active both locally and in a global store.
 *
 * Notes:
 * - Ensure `handleIndexRef` returns a valid index before dispatching and updating state.
 * - The dispatched action `setActiveContentTabIndex` presumably updates a Redux or context store.
 */
  const [activeIndex, setActiveIndex] = useState(0)
  const handleActiveIndex = (index) => {
    dispatch(setActiveContentTabIndex(index))
    setActiveIndex(index)
  }

  /**
 * @effect Sync Active Index with External `tempIndex`
 * @author Vishal Lohbande
 *
 * Description:
 * - React `useEffect` hook that updates the local `activeIndex` state whenever
 *   the external `tempIndex` value changes.
 *
 * Usage:
 * - Keeps the local component state `activeIndex` in sync with an external
 *   state or prop `tempIndex`.
 *
 * Notes:
 * - This ensures consistent active tab/section highlighting if `tempIndex` is
 *   updated from outside this component.
 */
  useEffect(() => {
    setActiveIndex(tempIndex)
  }, [tempIndex])

  const menuItems = [
    "Content",
    "Things included",
    "Videos",
    "Assignments",
    "Quiz",
    "Analytics",
    "Reviews",
    'Certification',
    "Rules & Regulations",
  ];

  const notify = () => {
    toast.dismiss(); // clear existing toasts 
    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        toast.success('link copied')
      });

  }

  /**
 * @constant windowWidth, setWindowWidth
 * @author Vishal Lohbande
 *
 * Description:
 * - Tracks the current width of the browser window.
 * - Initializes state with `window.innerWidth`.
 * - Sets up an event listener for the `resize` event on the window object.
 * - Updates `windowWidth` state whenever the window is resized.
 * - Cleans up the event listener on component unmount to prevent memory leaks.
 *
 * Usage:
 * - Useful for responsive UI components that need to adapt based on window size.
 *
 * Notes:
 * - This hook only adds the resize listener once on mount, due to the empty dependency array.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const swiperRef = useRef(null);
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeIndex]);

  return (
    <div className='C2wCourseAnimationBar_ctn'>
      {windowWidth > 620 &&
        <div className='C2wCourseAnimationBar_heading_ctn'>
          <img src='/assets/images/landing/c2wlogo.svg' alt='navbar-logo' onClick={() => navigate('/')} />
          <div className='C2wCourseAnimationBar_heading_title'>{courseData?.courseTitle}</div>
          <div className='C2wCourseAnimationBar_heading_fees'>
            {`₹ ${courseData?.fees}`}
            <span>{`+${courseData.gst}% GST`}</span>
          </div>
        </div>
      }
      <div className='C2wCourseAnimationBar_content_slider_ctn'>
        <div className='C2wCourseAnimationBar_content_slider'>
          <div className='C2wCourseContentSlider'>
            <Swiper pagination={{
              "clickable": true
            }} className="mySwiper"
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
                dispatch(setActiveContentTabIndex(swiper.activeIndex))
              }}
              is
              breakpoints={{
                360: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1260: {
                  slidesPerView: 8.2,
                  spaceBetween: 25,
                },
                1340: {
                  slidesPerView: 5.9,
                  spaceBetween: 90,
                },
                1366: {
                  slidesPerView: 5.9,
                  spaceBetween: 70,
                },
                1440: {
                  slidesPerView: 9,
                  spaceBetween: 25,
                },

                1536: {
                  slidesPerView: 7,
                  spaceBetween: 80,
                },

                1540: {
                  slidesPerView: 7,
                  spaceBetween: 80,
                },
                1920: {
                  slidesPerView: 7,
                  spaceBetween: 15,
                },
              }}
            >
              {menuItems && menuItems?.map((str, index) => (
                <SwiperSlide>
                  <Link onClick={() => {
                    dispatch(setActiveContentTabIndex(index));
                    handleActiveIndex(index)
                  }}
                    className={index === activeIndex ? `C2wContentBarActive_div` : 'C2wContent_div'}
                    to={`section${index}`}
                    smooth={true}
                    duration={500}
                    offset={ index === 0 ? -500 : -160}
                    containerId='C2wCourseDetailsContainer'
                  >{str}</Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {windowWidth > 620 &&
          <div className='C2wCourseAnimationBar_content_btn_hld'>
            <div className='C2wCourseBuy_div'>
              <button onClick={handlePopup}>
                {'Register Now'}
              </button>
              {/* <div className='C2wCourseBuy_ShareBg' onClick={!toastFlag ? notify : null}>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4971 7.32812C18.0159 7.32812 19.2471 6.09691 19.2471 4.57812C19.2471 3.05934 18.0159 1.82812 16.4971 1.82812C14.9783 1.82812 13.7471 3.05934 13.7471 4.57812C13.7471 6.09691 14.9783 7.32812 16.4971 7.32812Z" stroke="white" stroke-width="1.82814" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.49707 13.75C7.01585 13.75 8.24707 12.5188 8.24707 11C8.24707 9.48122 7.01585 8.25 5.49707 8.25C3.97829 8.25 2.74707 9.48122 2.74707 11C2.74707 12.5188 3.97829 13.75 5.49707 13.75Z" stroke="white" stroke-width="1.82814" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16.4971 20.168C18.0159 20.168 19.2471 18.9368 19.2471 17.418C19.2471 15.8992 18.0159 14.668 16.4971 14.668C14.9783 14.668 13.7471 15.8992 13.7471 17.418C13.7471 18.9368 14.9783 20.168 16.4971 20.168Z" stroke="white" stroke-width="1.82814" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.87109 12.3828L14.1319 16.0311" stroke="white" stroke-width="1.82814" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M14.1228 5.96875L7.87109 9.61708" stroke="white" stroke-width="1.82814" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div> */}
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default C2wCourseAnimationBar;
